// export function isInFilter(dateStr, filter) {
//   if (!dateStr) return false;

//   const d = new Date(dateStr + "T00:00:00");
//   const now = new Date();
//   const today = new Date(now.toDateString());
// console.log(d)
//   switch (filter) {
//     case "Today":
//       return d >= today;

//     case "Yesterday": {
//       const y = new Date(today);
//       y.setDate(y.getDate() - 1);
//       return d >= y && d < today;
//     }

//     case "Weekly": {
//       const start = new Date(today);
//       start.setDate(start.getDate() - 6);
//       return d >= start;
//     }

//     case "Monthly":
//       return (
//         d.getMonth() === now.getMonth() &&
//         d.getFullYear() === now.getFullYear()
//       );

//     default:
//       if (filter?.type === "Custom Date") {
//         return (
//           d >= new Date(filter.from + "T00:00:00") &&
//           d <= new Date(filter.to + "T23:59:59")
//         );
//       }
//       return true;
//   }
// }

export function isInFilter(dateStr, filter) {
  if (!dateStr) return false;

  // 🔑 normalize to LOCAL DATE (ignore time + timezone)
  const d = new Date(dateStr);
  const localDate = new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate()
  );

  const now = new Date();
  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  switch (filter) {
    case "Today":
      return localDate.getTime() === today.getTime();

    case "Yesterday": {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      return localDate.getTime() === y.getTime();
    }

    case "Weekly": {
      const start = new Date(today);
      start.setDate(start.getDate() - 6);
      return localDate >= start;
    }

    case "Monthly":
      return (
        localDate.getMonth() === today.getMonth() &&
        localDate.getFullYear() === today.getFullYear()
      );

    default:
      if (filter?.type === "Custom Date") {
        const from = new Date(filter.from);
        const to = new Date(filter.to);
        return localDate >= from && localDate <= to;
      }
      return true;
  }
}
